import { Navigate, useLocation } from "react-router-dom";

// Authentication only — every page is reachable by every signed-in role. Role no
// longer decides what is visible; it decides what you can DO, which is enforced
// per-control in the pages (the `!isReviewer` gates and the ObjectList action
// filter) and by class-level permissions on the server.
function Protected({ roles, children }) {
  const location = useLocation();
  if (roles.length > 0) {
    return children;
  } else {
    return <Navigate to={`/login?redirect=${location.pathname}`} replace />;
  }
}
export default Protected;
